export const scrollToAboutSection = () => {
    const section = document.getElementById('about-yj');
    if (section) {
        section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
};
